export default __webpack_public_path__ + "static/media/django-original.a65e52aa.svg";